module.exports = __webpack_public_path__ + "media/images/img/person-92691d214edbebf1e7a1f9d4e5643b72.jpg";